import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { priceFormatter } from "@/lib/utils";
import { Button } from "@bookips/solvook-ui-library";
import { Box, Divider, Stack, styled, Typography } from "@mui/material";
import useHandoutProductStore from "src/store/relatedProduct";
import CouponAlert from "./CouponAlert";
const PurchaseDivider = styled(Divider)((param)=>{
    let { theme  } = param;
    return {
        margin: theme.spacing(0, -2.5),
        borderColor: theme.palette.grey[50]
    };
});
const labelTextMap = {
    total: "합계 금액/상품 수",
    freepass: "상품 수",
    basicpass: "차감 금액/상품 수"
};
const buttonLabelMap = {
    total: "장바구니 담기",
    freepass: "이용권 사용하기",
    basicpass: "이용권 사용하기"
};
const PurchaseCTA = (param)=>{
    let { onClick , variant ="total" , isHandoutCoupons , onCouponClick  } = param;
    const { totalPrice , totalCount  } = useHandoutProductStore((param)=>{
        let { purchaseProductsInfo  } = param;
        return {
            totalPrice: purchaseProductsInfo.totalPrice,
            totalCount: purchaseProductsInfo.totalCount
        };
    });
    const isQuantityOnly = variant === "freepass";
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(PurchaseDivider, {}),
            /*#__PURE__*/ _jsxs(Box, {
                sx: {
                    my: 2.5
                },
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        sx: {
                            flexDirection: "row",
                            justifyContent: "space-between"
                        },
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                sx: {
                                    color: "text.secondary"
                                },
                                children: labelTextMap[variant]
                            }),
                            isQuantityOnly ? /*#__PURE__*/ _jsxs(Typography, {
                                variant: "body2",
                                sx: {
                                    color: "text.secondary"
                                },
                                children: [
                                    totalCount,
                                    "개"
                                ]
                            }) : /*#__PURE__*/ _jsxs(Stack, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 0.5,
                                children: [
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "body2",
                                        sx: {
                                            color: "text.secondary"
                                        },
                                        children: [
                                            priceFormatter(totalPrice),
                                            "원"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        variant: "body2",
                                        sx: {
                                            color: "text.disabled"
                                        },
                                        children: "/ ".concat(totalCount, "개")
                                    })
                                ]
                            })
                        ]
                    }),
                    variant === "total" && isHandoutCoupons && /*#__PURE__*/ _jsx(CouponAlert, {
                        onClick: onCouponClick
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "filledPrimary",
                size: "large",
                onClick: onClick,
                children: buttonLabelMap[variant]
            })
        ]
    });
};
export default PurchaseCTA;
